import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["permissionSection", "leadInviteSection", "planroomSelect"];
  static values = { leadJobPlanroomIds: Array };

  connect() {
    if (this.hasLeadInviteSectionTarget && this.hasPlanroomSelectTarget) {
      this.syncLeadInvite();
    }
  }

  syncLeadInvite() {
    const selectedId = parseInt(this.planroomSelectTarget.value, 10);
    const allowsLead = this.leadJobPlanroomIdsValue.includes(selectedId);
    this.leadInviteSectionTarget.classList.toggle("hidden", !allowsLead);

    if (!allowsLead) {
      const standardRadio = this.leadInviteSectionTarget.querySelector("input[type='radio'][value='false']");
      if (standardRadio && !standardRadio.checked) {
        standardRadio.checked = true;
      }
      if (this.hasPermissionSectionTarget) {
        this.permissionSectionTarget.classList.remove("hidden");
      }
    }
  }

  togglePermissions(event) {
    // Find the radio input - event.target could be the label or its children
    const label = event.target.closest("label");
    const input = label?.querySelector("input[type='radio']");

    if (!input) return;

    const isLeadJob = input.value === "true";

    if (isLeadJob) {
      this.permissionSectionTarget.classList.add("hidden");
    } else {
      this.permissionSectionTarget.classList.remove("hidden");
    }
  }
}
